import { render } from "./PredefinedTests.vue?vue&type=template&id=442bd9dc&scoped=true"
import script from "./PredefinedTests.vue?vue&type=script&lang=js"
export * from "./PredefinedTests.vue?vue&type=script&lang=js"

import "./PredefinedTests.vue?vue&type=style&index=0&id=442bd9dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442bd9dc"]])

export default __exports__